import React, { useState } from "react";
import axios from "axios";

const ClientLeads = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    company: "",
    phone: "",
    email: "",
    remarks: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      await axios.post("https://api.hanoch.in/users/client-leads/", formData);
      setSuccess("Client lead submitted successfully!");
      setFormData({
        name: "",
        company: "",
        phone: "",
        email: "",
        remarks: "",
      });
       setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to submit client lead. Please check your inputs."
      );
         setTimeout(() => setError(""), 3000);
    } finally {
      setLoading(false);
    }
  };

  // Input styles
  const inputStyle = {
    width: "100%",
    border: "1px solid #d0d7de",
    padding: "8px 12px",
    borderRadius: "6px",
    fontSize: "16px",
    lineHeight: "20px",
    color: "#24292f",
    backgroundColor: "#ffffff",
    transition: "0.2s ease border-color",
  };

  const inputFocus = {
    outline: "none",
    borderColor: "#0969da",
    boxShadow: "0 0 0 3px rgba(9, 105, 218, 0.3)",
  };

  // Button styles
  const btn = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: 500,
    borderRadius: "6px",
    padding: "8px 16px",
    border: "1px solid rgba(27,31,36,0.15)",
    cursor: "pointer",
    transition: "background-color 0.2s ease, border-color 0.2s ease",
  };

  const btnPrimary = {
    ...btn,
    backgroundColor: "#2da44e",
    color: "#fff",
    borderColor: "rgba(27,31,36,0.15)",
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundImage: "url('/20613.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        zIndex: 9999,
        overflowY: "auto",
        padding: "22px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 9999,
          overflowY: "auto",
          padding: "2px",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "-50px" }}>
          <img
            src="/haanochLog.png"
            alt="Logo"
            style={{ width: "600px", height: "300px" }}
          />
        </div>

        <div
          style={{
            maxWidth: "640px",
            margin: "0 auto",
            backgroundColor: "#ffffff",
            border: "1px solid #d0d7de",
            borderRadius: "7px",
            padding: "24px",
          }}
        >
          {/* <h2 style={{ fontSize: "20px", fontWeight: 600, marginBottom: "5px" }}>
            Client Lead Form
          </h2> */}

          {success && (
            <div
              style={{
                backgroundColor: "#dafbe1",
                color: "#1a7f37",
                padding: "8px 12px",
                borderRadius: "6px",
                marginBottom: "16px",
                border: "1px solid #1a7f37",
                fontSize: "14px",
              }}
            >
              {success}
            </div>
          )}
          {error && (
            <div
              style={{
                backgroundColor: "#ffebe9",
                color: "#cf222e",
                padding: "8px 12px",
                borderRadius: "6px",
                marginBottom: "16px",
                border: "1px solid #cf222e",
                fontSize: "14px",
              }}
            >
              {error}
            </div>
          )}

          {/* Form Grid Layout */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "16px",
            }}
          >
            {/* Row 1 */}
            <div>
              <label style={{ fontSize: "14px", marginBottom: "4px", display: "block" }}>
                Name *
              </label>
              <input
                type="text"
                name="name"
                style={inputStyle}
                onFocus={(e) => Object.assign(e.target.style, inputFocus)}
                onBlur={(e) => Object.assign(e.target.style, inputStyle)}
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label style={{ fontSize: "14px", marginBottom: "4px", display: "block" }}>
                Company (Optional)
              </label>
              <input
                type="text"
                name="company"
                style={inputStyle}
                onFocus={(e) => Object.assign(e.target.style, inputFocus)}
                onBlur={(e) => Object.assign(e.target.style, inputStyle)}
                value={formData.company}
                onChange={handleChange}
              />
            </div>

            {/* Row 2 */}
            <div>
              <label style={{ fontSize: "14px", marginBottom: "4px", display: "block" }}>
                Phone *
              </label>
              <input
                type="text"
                name="phone"
                style={inputStyle}
                onFocus={(e) => Object.assign(e.target.style, inputFocus)}
                onBlur={(e) => Object.assign(e.target.style, inputStyle)}
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label style={{ fontSize: "14px", marginBottom: "4px", display: "block" }}>
                Email (Optional)
              </label>
              <input
                type="email"
                name="email"
                style={inputStyle}
                onFocus={(e) => Object.assign(e.target.style, inputFocus)}
                onBlur={(e) => Object.assign(e.target.style, inputStyle)}
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            {/* Full width remarks */}
            <div style={{ gridColumn: "1 / -1" }}>
              <label style={{ fontSize: "14px", marginBottom: "4px", display: "block" }}>
                Remarks (Optional)
              </label>
              <textarea
                name="remarks"
                rows="4"
                style={{ ...inputStyle, resize: "vertical" }}
                onFocus={(e) => Object.assign(e.target.style, inputFocus)}
                onBlur={(e) => Object.assign(e.target.style, inputStyle)}
                value={formData.remarks}
                onChange={handleChange}
              />
            </div>

            {/* Full width button */}
            <div style={{ gridColumn: "1 / -1", textAlign: "center" }}>
              <button
                onClick={handleSubmit}
                disabled={loading}
                style={{
                  ...btnPrimary,
                  opacity: loading ? 0.7 : 1,
                  cursor: loading ? "not-allowed" : "pointer",
                }}
                onMouseOver={(e) =>
                  !loading && (e.target.style.backgroundColor = "#2c974b")
                }
                onMouseOut={(e) =>
                  !loading && (e.target.style.backgroundColor = "#2da44e")
                }
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientLeads;
